import { render, staticRenderFns } from "./assigned.vue?vue&type=template&id=451b87f7&"
import script from "./assigned.vue?vue&type=script&lang=js&"
export * from "./assigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports